export async function sendApiRequest<T>(
  url: `/${string}`,
  body?: object
): Promise<T> {
  const res = await fetch(`/api${url}`, {
    method: body ? "POST" : "GET",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  const jsonResponse = await res.json();

  return jsonResponse as T;
}
